import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AiMakeSourceRecordListByTypeResponse {
  page: number;
  page_size: number;
  records: Array<AiMakeMessageRecord>;
  total: number;
  image_total: number;
  video_total: number;
};

export interface AiMakeMessageRecord {
  id: number;
  record_id: number;
  url: string;
  s3_url: string;
  video_duration: number;
  status: number;
  create_time: number;
  type: number;
  mid_task_id?: string;
};

// 请求接口
interface AiMakeSourceRecordListByTypeRequest {
  agentId: string;
  /** 创作类型 1: 图片 2: 视频 */
  type: number;
  page?: number;
  pageSize?: number;
}

export class AiMakeMessageRecordData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("RecordId cannot be empty")
  @IsNumber("RecordId must be a number")
  recordId: number;

  @Required("Url cannot be empty")
  @IsString("Url must be a string")
  url: string;

  @Required("S3Url cannot be empty")
  @IsString("S3Url must be a string")
  s3Url: string;

  @Required("VideoDuration cannot be empty")
  @IsNumber("VideoDuration must be a number")
  videoDuration: number;

  @Required("Status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  @Required("CreateTime cannot be empty")
  @IsNumber("CreateTime must be a number")
  createTime: number;

  @Required("Type cannot be empty")
  @IsNumber("Type must be a number")
  type: number;

  @IsString("MidTaskId must be a string")
  midTaskId?: string;
}

export class AiMakeSourceRecordListByTypeData {
  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("PageSize cannot be empty")
  @IsNumber("PageSize must be a number")
  pageSize: number;

  // @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Total cannot be empty")
  @IsNumber("ImageTotal must be a number")
  imageTotal: number;

  @Required("Total cannot be empty")
  @IsNumber("VideoTotal must be a number")
  videoTotal: number;

  @IsArray("Records must be an array")
  @Required("Records cannot be empty")
  records: AiMakeMessageRecordData[];
}

const transformAndValidateAgent = (
  response: AiMakeSourceRecordListByTypeResponse
): AiMakeSourceRecordListByTypeData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AiMakeSourceRecordListByTypeData);
  } catch (error) {
    console.error("subscribe Agent data validation failed:", error.message);
    throw error;
  }
};

/** Ai创作结果记录 */
export const aiMakeSourceRecordListByType = async ({ agentId, type, page, pageSize }: AiMakeSourceRecordListByTypeRequest): Promise<AiMakeSourceRecordListByTypeData> => {
  const response = await api.post<AiMakeSourceRecordListByTypeResponse>('/ai_make_source_record/list_by_type', {
    type,
    page,
    page_size: pageSize,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
